import is from 'typescript-styled-is'
import styled from '../../../../theme'

const DatePickerContent = styled.div<IDatePickerContentProps>`
  position: relative;
  background: #ffffff;
  border-radius: 0px 0px 10px 10px;
  overflow: hidden;
  transition: width 0.8s;

  height: 360px;
  ${is('sized')`
    height: 214px;
  `}

  ${is('monthOnly')`
    height: 117px;
  `}
`

export default DatePickerContent

export interface IDatePickerContentProps {
  sized?: boolean
  monthOnly?: boolean
}
